import { BetQLPickTypes } from "./";

const PICK_TYPES: BetQLPickTypes = {
  spread: {
    name: "Spread",
    shortName: "Spread",
    abbrev: "Sp",
    key: "SPREAD",
    linePeriod: "FULLGAME",
    linePeriodKey: "FG",
    filterKey: "spread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "currentFGspreadAwayDisplay",
    homeKey: "currentFGspreadHomeDisplay",
    awayPriceKey: "currentFGAwayPriceDisplay",
    homePriceKey: "currentFGHomePriceDisplay",
    favoriteIndex: 0,
  },
  moneyline: {
    name: "Moneyline",
    shortName: "Moneyline",
    abbrev: "ML",
    key: "MONEYLINE",
    linePeriod: "FULLGAME",
    linePeriodKey: "FG",
    filterKey: "moneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    drawDisplay: "--",
    awayKey: "currentFGmoneylineAwayDisplay",
    homeKey: "currentFGmoneylineHomeDisplay",
    drawKey: "currentFGmoneylineDrawDisplay",
    awayPriceKey: "currentFGmoneylineAwayDisplay",
    homePriceKey: "currentFGmoneylineHomeDisplay",
    drawPriceKey: "currentFGmoneylineDrawDisplay",
    favoriteIndex: 0,
  },
  total: {
    name: "Total",
    shortName: "Total",
    abbrev: "O/U",
    key: "TOTAL",
    linePeriod: "FULLGAME",
    linePeriodKey: "FG",
    filterKey: "total",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "currentFGtotalAwayDisplay",
    homeKey: "currentFGtotalAwayDisplay",
    awayPriceKey: "currentFGOverPriceDisplay",
    homePriceKey: "currentFGUnderPriceDisplay",
    favoriteIndex: 0,
  },
  "1Hspread": {
    name: "1st Half Spread",
    shortName: "1H Spread",
    abbrev: "1H Sp",
    key: "FIRSTHALFSPREAD",
    linePeriod: "FIRSTHALF",
    linePeriodKey: "1H",
    filterKey: "1Hspread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1HspreadAwayDisplay",
    homeKey: "current1HspreadHomeDisplay",
    awayPriceKey: "current1HAwayPriceDisplay",
    homePriceKey: "current1HHomePriceDisplay",
    favoriteIndex: 0,
  },
  "1Hmoneyline": {
    name: "1st Half Moneyline",
    shortName: "1H Moneyline",
    abbrev: "1H ML",
    key: "FIRSTHALFMONEYLINE",
    linePeriod: "FIRSTHALF",
    linePeriodKey: "1H",
    filterKey: "1Hmoneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    drawDisplay: "--",
    awayKey: "current1HmoneylineAwayDisplay",
    homeKey: "current1HmoneylineHomeDisplay",
    drawKey: "current1HmoneylineDrawDisplay",
    awayPriceKey: "current1HmoneylineAwayDisplay",
    homePriceKey: "current1HmoneylineHomeDisplay",
    drawPriceKey: "current1HmoneylineDrawDisplay",
    favoriteIndex: 0,
  },
  "1Htotal": {
    name: "1st Half Total",
    shortName: "1H Total",
    abbrev: "1H O/U",
    key: "FIRSTHALFTOTAL",
    linePeriod: "FIRSTHALF",
    linePeriodKey: "1H",
    filterKey: "1Htotal",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1HtotalAwayDisplay",
    homeKey: "current1HtotalAwayDisplay",
    awayPriceKey: "current1HOverPriceDisplay",
    homePriceKey: "current1HUnderPriceDisplay",
    favoriteIndex: 0,
  },
  "2Hspread": {
    name: "2nd Half Spread",
    shortName: "2H Spread",
    abbrev: "2H Sp",
    key: "SECONDHALFSPREAD",
    linePeriod: "SECONDHALF",
    linePeriodKey: "2H",
    filterKey: "2Hspread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current2HspreadAwayDisplay",
    homeKey: "current2HspreadHomeDisplay",
    awayPriceKey: "current2HAwayPriceDisplay",
    homePriceKey: "current2HHomePriceDisplay",
    favoriteIndex: 0,
  },
  "2Hmoneyline": {
    name: "2nd Half Moneyline",
    shortName: "2H Moneyline",
    abbrev: "2H ML",
    key: "SECONDHALFMONEYLINE",
    linePeriod: "SECONDHALF",
    linePeriodKey: "2H",
    filterKey: "2Hmoneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    drawDisplay: "--",
    awayKey: "current2HmoneylineAwayDisplay",
    homeKey: "current2HmoneylineHomeDisplay",
    drawKey: "current2HmoneylineDrawDisplay",
    awayPriceKey: "current2HmoneylineAwayDisplay",
    homePriceKey: "current2HmoneylineHomeDisplay",
    drawPriceKey: "current2HmoneylineDrawDisplay",
    favoriteIndex: 0,
  },
  F5spread: {
    name: "First 5 Inn. Spread",
    shortName: "1st 5 Spread",
    abbrev: "F5 Sp",
    key: "FIRSTHALFSPREAD",
    linePeriod: "FIRSTHALF",
    linePeriodKey: "1H",
    filterKey: "1Hspread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1HspreadAwayDisplay",
    homeKey: "current1HspreadHomeDisplay",
    awayPriceKey: "current1HAwayPriceDisplay",
    homePriceKey: "current1HHomePriceDisplay",
    favoriteIndex: 0,
  },
  F5moneyline: {
    name: "First 5 Inn. Moneyline",
    shortName: "1st 5 Moneyline",
    abbrev: "F5 ML",
    key: "FIRSTHALFMONEYLINE",
    linePeriod: "FIRSTHALF",
    linePeriodKey: "1H",
    filterKey: "1Hmoneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1HmoneylineAwayDisplay",
    homeKey: "current1HmoneylineHomeDisplay",
    awayPriceKey: "current1HmoneylineAwayDisplay",
    homePriceKey: "current1HmoneylineHomeDisplay",
    favoriteIndex: 0,
  },
  F5total: {
    name: "First 5 Inn. Total",
    shortName: "1st 5 Total",
    abbrev: "F5 O/U",
    key: "FIRSTHALFTOTAL",
    linePeriod: "FIRSTHALF",
    linePeriodKey: "1H",
    filterKey: "1Htotal",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1HtotalAwayDisplay",
    homeKey: "current1HtotalAwayDisplay",
    awayPriceKey: "current1HOverPriceDisplay",
    homePriceKey: "current1HUnderPriceDisplay",
    favoriteIndex: 0,
  },
  S5spread: {
    name: "Second Half Inn. Spread",
    shortName: "S5 Spread",
    abbrev: "S5 Sp",
    key: "SECONDHALFSPREAD",
    linePeriod: "SECONDHALF",
    linePeriodKey: "2H",
    filterKey: "2Hspread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current2HspreadAwayDisplay",
    homeKey: "current2HspreadHomeDisplay",
    awayPriceKey: "current2HAwayPriceDisplay",
    homePriceKey: "current2HHomePriceDisplay",
    favoriteIndex: 0,
  },
  S5moneyline: {
    name: "Second Half Inn. Moneyline",
    shortName: "S5 Moneyline",
    abbrev: "S5 ML",
    key: "SECONDHALFMONEYLINE",
    linePeriod: "SECONDHALF",
    linePeriodKey: "2H",
    filterKey: "2Hmoneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current2HmoneylineAwayDisplay",
    homeKey: "current2HmoneylineHomeDisplay",
    awayPriceKey: "current2HmoneylineAwayDisplay",
    homePriceKey: "current2HmoneylineHomeDisplay",
    favoriteIndex: 0,
  },
  "1Pmoneyline": {
    name: "1st Period Moneyline",
    shortName: "1P Moneyline",
    abbrev: "1P ML",
    key: "FIRSTPERIODMONEYLINE",
    linePeriod: "FIRSTPERIOD",
    linePeriodKey: "1P",
    filterKey: "1Pmoneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1PmoneylineAwayDisplay",
    homeKey: "current1PmoneylineHomeDisplay",
    awayPriceKey: "current1PmoneylineAwayDisplay",
    homePriceKey: "current1PmoneylineHomeDisplay",
    favoriteIndex: 0,
  },
  "1Pspread": {
    name: "1st Period Spread",
    shortName: "1P Spread",
    abbrev: "1P Sp",
    key: "FIRSTPERIODSPREAD",
    linePeriod: "FIRSTPERIOD",
    linePeriodKey: "1P",
    filterKey: "1Pspread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1PspreadAwayDisplay",
    homeKey: "current1PspreadHomeDisplay",
    awayPriceKey: "current1PAwayPriceDisplay",
    homePriceKey: "current1PHomePriceDisplay",
    favoriteIndex: 0,
  },
  "1Ptotal": {
    name: "1st Period Total",
    shortName: "1P Total",
    abbrev: "1P O/U",
    key: "FIRSTPERIODTOTAL",
    linePeriod: "FIRSTPERIOD",
    linePeriodKey: "1P",
    filterKey: "1Ptotal",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current1PtotalAwayDisplay",
    homeKey: "current1PtotalAwayDisplay",
    awayPriceKey: "current1POverPriceDisplay",
    homePriceKey: "current1PUnderPriceDisplay",
    favoriteIndex: 0,
  },
  "2Pmoneyline": {
    name: "2nd Period Moneyline",
    shortName: "2P Moneyline",
    abbrev: "2P ML",
    key: "SECONDPERIODMONEYLINE",
    linePeriod: "SECONDPERIOD",
    linePeriodKey: "2P",
    filterKey: "2Pmoneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current2PmoneylineAwayDisplay",
    homeKey: "current2PmoneylineHomeDisplay",
    awayPriceKey: "current2PmoneylineAwayDisplay",
    homePriceKey: "current2PmoneylineHomeDisplay",
    favoriteIndex: 0,
  },
  "2Pspread": {
    name: "2nd Period Spread",
    shortName: "2P Spread",
    abbrev: "2P Sp",
    key: "SECONDPERIODSPREAD",
    linePeriod: "SECONDPERIOD",
    linePeriodKey: "2P",
    filterKey: "2Pspread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current2PspreadAwayDisplay",
    homeKey: "current2PspreadHomeDisplay",
    awayPriceKey: "current2PAwayPriceDisplay",
    homePriceKey: "current2PHomePriceDisplay",
    favoriteIndex: 0,
  },
  "3Pmoneyline": {
    name: "3rd Period Moneyline",
    shortName: "3P Moneyline",
    abbrev: "3P ML",
    key: "THIRDPERIODMONEYLINE",
    linePeriod: "THIRDPERIOD",
    linePeriodKey: "3P",
    filterKey: "3Pmoneyline",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current3PmoneylineAwayDisplay",
    homeKey: "current3PmoneylineHomeDisplay",
    awayPriceKey: "current3PmoneylineAwayDisplay",
    homePriceKey: "current3PmoneylineHomeDisplay",
    favoriteIndex: 0,
  },
  "3Pspread": {
    name: "3rd Period Spread",
    shortName: "3P Spread",
    abbrev: "3P Sp",
    key: "THIRDPERIODSPREAD",
    linePeriod: "THIRDPERIOD",
    linePeriodKey: "3P",
    filterKey: "3Pspread",
    awayDisplay: "--",
    homeDisplay: "--",
    awayKey: "current3PspreadAwayDisplay",
    homeKey: "current3PspreadHomeDisplay",
    awayPriceKey: "current3PAwayPriceDisplay",
    homePriceKey: "current3PHomePriceDisplay",
    favoriteIndex: 0,
  },
};

export default PICK_TYPES;
